{
  "_fallback": "An error occurred",

  "backup_archive_missing": "Backup file not found",
  "backup_manifest_missing": "Backup has no manifest",
  "backup_manifest_unreadable": "Manifest unreadable",
  "backup_manifest_invalid": "Manifest format invalid",
  "backup_version_unsupported": "Backup version {{version}} not supported",
  "backup_kind_mismatch": "Wrong backup kind: {{kind}}",
  "backup_tar_corrupt": "Tar archive corrupted: {{error}}",
  "backup_db_unreadable": "Database in backup unreadable",
  "backup_db_corrupt": "Database in backup corrupted: {{detail}}",
  "backup_filename_missing": "Filename missing",
  "backup_create_failed": "Backup creation failed: {{error}}",
  "backup_restore_failed": "Restore failed: {{error}}",

  "invalid_credentials": "Invalid credentials",
  "too_many_login_attempts": "Too many failed login attempts, please try again later.",
  "not_authenticated": "Not authenticated",
  "token_expired": "Token expired",
  "invalid_token": "Invalid token",
  "admin_only": "Admin only",

  "agent_not_found": "Agent not found",
  "agent_no_access": "No access to this agent",
  "soul_active": "Soul is active — the system prompt is not used. Edit the soul in the “Soul” tab or clear all fields there.",

  "session_not_found": "Session not found",
  "session_no_access": "No access to this session",
  "upload_file_too_large": "{{filename}} is too large. Maximum {{max_mib}} MiB per file.",
  "upload_total_too_large": "The attachments are too large in total. Maximum {{max_mib}} MiB per message.",
  "upload_too_many_files": "A maximum of {{max_files}} files per message is allowed.",
  "upload_size_unknown": "The file size could not be determined.",

  "project_not_found": "Project not found",
  "project_no_access": "No access to this project",
  "project_agent_not_found": "Project agent not found",

  "mcp_server_not_found": "MCP server not found",
  "mcp_template_not_found": "Template '{{template_id}}' unknown",
  "mcp_connection_failed": "Connection failed: {{message}}",
  "mcp_tool_listing_failed": "Tool listing failed: {{message}}",

  "llm_test_failed": "LLM test failed: {{message}}",

  "update_script_missing": "Update script not found — only available in production setup",
  "update_trigger_failed": "Update trigger failed: {{message}}",
  "restart_trigger_failed": "Restart trigger failed: {{message}}",

  "plugin_hub_unreachable": "Plugin hub unreachable: {{message}}",
  "plugin_install_failed": "Plugin install failed: {{message}}",
  "plugin_uninstall_failed": "Plugin uninstall failed: {{message}}",
  "plugin_update_failed": "Plugin update failed: {{message}}",

  "username_exists": "Username already exists",
  "user_not_found": "User not found",
  "last_admin_cannot_demote": "Cannot demote the last admin",
  "invalid_role": "Invalid role: {{role}}",
  "agentlink_not_configured": "AgentLink is not configured (HH_AGENTLINK_URL missing)",
  "agentlink_listener_never_started": "Listener was never started — service restart required",
  "agentlink_failed": "AgentLink reconnect failed: {{detail}}",
  "message_not_found": "Message not found",
  "message_not_editable": "Only user messages can be edited",
  "vm_must_be_stopped": "VM must be stopped to edit (currently: {{state}})",
  "vm_name_invalid": "Invalid VM name: {{name}}",
  "vm_name_taken": "VM name already taken: {{name}}",
  "vm_iso_not_found": "ISO not found: {{filename}}",
  "vm_disk_shrink_not_supported": "Disk shrink not supported (currently {{current}} GB, requested {{requested}} GB)",
  "qcow2_resize_failed": "Disk resize failed: {{stderr}}",
  "qcow2_missing": "qcow2 disk missing: {{path}}",
  "qemu_img_missing": "qemu-img not installed",
  "container_must_be_stopped": "Container must be stopped to edit (currently: {{state}})",
  "container_name_invalid": "Invalid container name: {{name}}",
  "container_name_taken": "Container name already taken: {{name}}",
  "git_failed": "Git operation failed: {{detail}}",
  "git_no_repo": "No git repository in this workspace — please clone or init empty first.",
  "git_no_remote": "No remote configured.",
  "git_no_changes": "No changes to commit.",
  "git_workspace_not_empty": "Workspace not empty — clone only works in empty workspaces.",
  "git_empty_message": "Commit message must not be empty.",
  "git_timeout": "Git operation timed out.",

  "channel_unavailable": "Channel '{{channel}}' unavailable",

  "vm_not_found": "VM not found",
  "vm_no_access": "No permission for this VM",
  "vm_name_invalid": "Invalid VM name (1–32 chars, must start with letter, only a-z A-Z 0-9 -)",
  "vm_name_taken": "A VM with this name already exists",
  "vm_network_mode_invalid": "Unknown network mode",
  "vm_disk_interface_invalid": "Invalid disk interface '{{value}}' — allowed: virtio, sata, ide",
  "vm_machine_type_invalid": "Invalid machine type '{{value}}' — allowed: q35, pc",
  "vm_network_device_invalid": "Invalid network device '{{value}}' — allowed: virtio-net-pci, e1000",
  "iso_not_found": "ISO '{{filename}}' not found",
  "iso_invalid_name": "Invalid ISO filename",
  "iso_invalid_format": "File is not valid ISO-9660 (magic '{{magic}}')",
  "iso_too_large": "ISO too large ({{size}} bytes, max {{max}})",
  "iso_already_exists": "ISO '{{filename}}' already exists",
  "iso_read_failed": "ISO could not be read: {{error}}",
  "qemu_img_missing": "qemu-img not installed — please install qemu-utils package",
  "qemu_system_missing": "qemu-system-x86_64 not installed",
  "qemu_start_failed": "QEMU start failed (rc={{rc}})",
  "qemu_daemonize_timeout": "QEMU daemon start timeout",
  "qemu_died_after_start": "QEMU process died after start",
  "qemu_process_died": "QEMU process exited unexpectedly (detected by reconciler)",
  "qcow2_create_failed": "qcow2 creation failed (rc={{rc}})",
  "qcow2_exists": "qcow2 file already exists: {{path}}",
  "qcow2_missing": "qcow2 file missing: {{path}}",
  "vnc_ports_exhausted": "All VNC ports (5900–5999) in use",
  "vm_not_running": "VM not running — console available only after start",
  "snapshot_not_found": "Snapshot not found",
  "snapshot_name_invalid": "Invalid snapshot name (1-64 chars, only a-z A-Z 0-9 _ . -)",
  "snapshot_vm_not_stopped": "VM must be stopped for snapshot operations",
  "snapshot_create_failed": "Snapshot creation failed (rc={{rc}})",
  "snapshot_restore_failed": "Snapshot restore failed (rc={{rc}})",
  "snapshot_delete_failed": "Snapshot delete failed (rc={{rc}})",
  "import_source_missing": "Source file missing or unreadable",
  "import_format_unknown": "Disk format could not be detected",
  "import_format_unsupported": "Format '{{format}}' is not supported (qcow2/raw/vmdk/vdi/vhd/vhdx)",
  "import_convert_failed": "qemu-img convert failed (rc={{rc}})",
  "import_upload_failed": "Upload failed: {{error}}",
  "import_internal_error": "Internal import error",
  "import_job_not_found": "Import job not found",
  "import_job_not_done": "Import job not finished yet (status: {{status_}})",
  "import_qcow2_missing": "qcow2 for import job missing — probably deleted",
  "import_move_failed": "Could not move import qcow2: {{error}}",
  "container_not_found": "Container not found",
  "container_no_access": "No permission for this container",
  "container_name_invalid": "Invalid container name (1-63 chars, must start with letter, only a-z A-Z 0-9 -)",
  "container_name_taken": "A container with this name already exists",
  "container_network_mode_invalid": "Unknown network mode",
  "container_not_running": "Container not running (detected by reconciler)",
  "incus_missing": "incus not installed — installer phase 10 pending",
  "incus_timeout": "incus command timeout",
  "incus_launch_failed": "incus launch failed: {{stderr}}",
  "incus_start_failed": "incus start failed: {{stderr}}",
  "incus_stop_failed": "incus stop failed: {{stderr}}",
  "incus_restart_failed": "incus restart failed: {{stderr}}",
  "incus_delete_failed": "incus delete failed: {{stderr}}",

  "upload_file_too_large": "The file “{{filename}}” is larger than {{max_mib}} MiB.",
  "upload_total_too_large": "The attachments exceed the combined {{max_mib}} MiB limit.",
  "upload_too_many_files": "A message can contain at most {{max_files}} attachments.",
  "upload_size_unknown": "The size of an attachment could not be determined safely.",
  "upload_request_too_large": "The upload request, including transfer overhead, exceeds {{max_mib}} MiB.",

  "ollama_not_configured": "Ollama has not been configured yet.",
  "ollama_unreachable": "Ollama is unavailable.",
  "ollama_library_unavailable": "The official Ollama Library is unavailable.",
  "invalid_ollama_family": "Invalid Ollama model family.",
  "invalid_ollama_model": "Invalid Ollama model name.",
  "ollama_pull_not_found": "Ollama download not found.",
  "ollama_model_not_found": "The Ollama model is not installed.",
  "ollama_model_in_use": "The model is still in use: {{references}}",

  "local_media_blocked": "Installation blocked ({{reason}}).",
  "local_media_busy": "An action for local image/video generation is already running.",
  "local_media_not_installed": "Local image/video generation is not installed.",

  "group_exists": "A group with this name already exists",
  "group_not_found": "Group not found",
  "capability_unknown": "Unknown feature: {{capability}}",
  "subject_invalid": "Invalid grant recipient",
  "capability_denied": "No access to this feature ({{capability}})",

  "validation_error": "{{message}}",
  "session_required": "This needs a login session, an API key is not enough",

  "peer_not_found": "Partner server not found",
  "peer_code_invalid": "Invalid pairing code",
  "peer_is_self": "This is this server's own pairing code",
  "peer_exists": "This partner server is already paired",
  "peer_fingerprint_mismatch": "Fingerprint does not match",
  "peer_agent_unknown": "Agent {{agent_id}} does not exist here"
}
